import "core-js/modules/es.array.index-of";

/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import logger from '../logger/logger';

var detectFraud = function detectFraud(_ref) {
  var _ref$uri = _ref.uri,
      uri = _ref$uri === void 0 ? '' : _ref$uri,
      sessionId = _ref.sessionId,
      placementValue = _ref.placementValue;

  if (uri) {
    var baseUrl = uri;
    var jsURI = baseUrl.substring(0, baseUrl.indexOf('/ATADUN'));
    var nds = window.ndsapi || (window.ndsapi = {});
    logger.debug("NUDATA Detect Fraud: ".concat(placementValue));
    nds.config = {
      q: [],
      ready: function ready(cb) {
        nds.config.q.push(cb);
      }
    };
    nds.config.ready(function () {
      nds.setPlacement(placementValue);
      nds.setSessionId(sessionId);
    });
    var js = document.createElement('script');
    var fjs = document.getElementsByTagName('script')[0];
    js.src = jsURI + '/jenny/nd';
    fjs.parentNode.insertBefore(js, fjs);

    js.onload = function () {
      nds.load(baseUrl);
    };
  }
};

export default detectFraud;